import { Col, Row } from 'reactstrap';
import { useFormState } from 'utils/hooks';

import Input from 'common/components/form/inputs/Input';

const Countries = ({ formState }) => {
  const { fields, changeField } = useFormState(formState);

  return (
    <div>
      <Row className="no-gutters">
        <Col>
          <Input label="Name" onChange={changeField('name')} {...fields.name} />
        </Col>
      </Row>
      <Row className="no-gutters">
        <Col>
          <Input label="Code" onChange={changeField('code')} {...fields.code} />
        </Col>
      </Row>
    </div>
  );
};

export default Countries;
